import { z } from 'zod';
import { baseString } from './core/primitives';
import { str } from './core/helpers';

const WT_NAME_MAX = 255;
const WT_DESCRIPTION_MAX = 2000;

export const createWorkflowTemplateSchema = (t) =>
  z.object({
    name: z.preprocess(
      str,
      baseString
        .min(1, t('validation.workflowTemplate.name.required'))
        .max(
          WT_NAME_MAX,
          t('validation.workflowTemplate.name.maxLength', { max: WT_NAME_MAX })
        )
    ),
    description: baseString
      .max(
        WT_DESCRIPTION_MAX,
        t('validation.workflowTemplate.description.maxLength', {
          max: WT_DESCRIPTION_MAX,
        })
      )
      .optional(),
  });

export const updateWorkflowTemplateSchema = (t) =>
  z.object({
    name: z
      .preprocess(
        str,
        baseString.min(1, t('validation.workflowTemplate.name.required')).max(
          WT_NAME_MAX,
          t('validation.workflowTemplate.name.maxLength', {
            max: WT_NAME_MAX,
          })
        )
      )
      .optional(),
    description: baseString
      .max(
        WT_DESCRIPTION_MAX,
        t('validation.workflowTemplate.description.maxLength', {
          max: WT_DESCRIPTION_MAX,
        })
      )
      .optional(),
  });

export { WT_NAME_MAX, WT_DESCRIPTION_MAX };
